import React from 'react';
import { Switch } from 'components/Switch/Switch';
import Text from 'components/Text/Text';

interface IProps {
	generateQrInstantly: boolean;
	isDisabled: boolean;
	onToggleGenerateQrInstantly: () => void;
}

export const GenerateQrInstantlySwitch: React.FC<IProps> = React.memo(
	({ generateQrInstantly, isDisabled, onToggleGenerateQrInstantly }) => {
		return (
			<div className="flex flex-col gap-1.5" data-test="GenerateQrInstantlySwitch">
				<div className="flex items-center gap-2.5">
					<Switch
						checked={generateQrInstantly}
						isDisabled={isDisabled}
						onChange={onToggleGenerateQrInstantly}
					/>
					<Text
						translationNameSpace="form"
						translationKey="bankSettingsGenerateQrInstantlyLabel"
						display="inline"
					/>
				</div>
				{isDisabled && (
					<Text
						translationNameSpace="form"
						translationKey="bankSettingsGenerateQrInstantlyHint"
						size="xs"
						theme="neutralLight"
					/>
				)}
			</div>
		);
	},
);
